export default __webpack_public_path__ + "static/bentoImg5Mob-5e6be016191c1d9fda44fe57ee8cac9b.webp";